import { IModificationInfo } from 'types/creationDetails'
import { IPaginationInfo } from 'types/pagination'

export enum EPaymentHistoryStatus {
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
}

export enum EPaymentPayerStatus {
  ERROR = 'ERROR',
  CREATED = 'CREATED',
  DECLINED = 'DECLINED',
  AUTHORIZED = 'AUTHORIZED',
}

export type TPaymentPayerStatus = {
  status: EPaymentPayerStatus
  message: string
  shouldRetry: boolean
}

export type IPaymentsHistory = {
  info: IPaginationInfo
  items: IPaymentHistory[]
}

export interface IPaymentHistory extends IModificationInfo {
  id: string
  paymentOrganizationId: string
  paymentLotId: string
  paymentStatus: EPaymentHistoryStatus
  amount: number
  currency: string
  createdAt: string
  updatedAt: string
  transactionType: number
  backReference: string
  language: string
  orderId: string
  description: string
  merchantName: string
  merchantUrl: string
  customerName: string
  customerPhone: string
  terminalId: number
  action: number
  rc: string
  approval: string
  rrn: string
  intRef: string
  timestamp: string
  gatewayTimestamp: string
}

export type TPaymentResponse = {
  AMOUNT: number
  CURRENCY: string
  ORDER: string
  DESC: string
  MERCH_NAME: string
  MERCH_URL: string
  TERMINAL: number
  TRTYPE: number
  BACKREF: string
  LANG: string
  NAME: string
  M_INFO: string
  NONCE: string
  P_SIGN: string
  TIMESTAMP: string
}
